import { render, staticRenderFns } from "./formItemModal.vue?vue&type=template&id=a0e48036"
import script from "../../controllers/application_form/form-item-modal.js?vue&type=script&lang=js&external"
export * from "../../controllers/application_form/form-item-modal.js?vue&type=script&lang=js&external"
import style0 from "./formItemModal.vue?vue&type=style&index=0&id=a0e48036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports